import { render, staticRenderFns } from "./SmsSettingsSidePanel.vue?vue&type=template&id=d3df72ce&scoped=true&"
import script from "./SmsSettingsSidePanel.vue?vue&type=script&lang=js&"
export * from "./SmsSettingsSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SmsSettingsSidePanel.vue?vue&type=style&index=0&id=d3df72ce&prod&scoped=true&lang=css&"
import style1 from "./SmsSettingsSidePanel.vue?vue&type=style&index=1&id=d3df72ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3df72ce",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsSidePanel%2FSmsSettingsSidePanel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports